export default __webpack_public_path__ + "static/media/buyume-logo 3.623b568a.svg";